const CACHE = {
  countries: [],
  states: [],
  usaDefault: '',
}

export const setCountryOptions = (countries) => {
  CACHE.countries = countries
  const usa = (countries || []).find((country) => country.value.toUpperCase() === 'UNITED STATES')
  CACHE.usaDefault = usa ? usa.value : 'United States'
}

export const getCountryOptions = () => {
  return CACHE.countries
}

export const getUSADefault = () => {
  return CACHE.usaDefault
}

export const setStateOptions = (states) => {
  CACHE.states = states
}

export const getStateOptions = (includeNA = false) => {
  return includeNA ? CACHE.states : CACHE.states.filter((state) => state.value !== 'NA')
}

export const filteredStateOptions = () =>
  getStateOptions().filter(({ value }) => value !== process.env.STATE_ABBR)

